import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Search, ChevronDown, ChevronRight, Plus, Upload, FileText, Eye, Star, Bot, MoreVertical, X } from 'lucide-react';
const PROCEDURE_TABS = [{
  label: 'Library',
  path: ''
}, {
  label: 'AI Agents',
  path: 'ai-agents'
}, {
  label: 'Onboarding',
  path: 'onboarding'
}, {
  label: 'Analytics',
  path: 'analytics'
}];
const CATEGORIES = [{
  name: '🍔 Kitchen Operations',
  count: 8,
  expanded: true
}, {
  name: '📦 Order Handling',
  count: 5,
  expanded: false
}, {
  name: '🏪 Opening & Closing',
  count: 4,
  expanded: false
}, {
  name: '🔧 Equipment & Troubleshooting',
  count: 4,
  expanded: false
}, {
  name: '👥 HR & Policies',
  count: 3,
  expanded: false
}];
const DOCUMENTS = [{
  id: 1,
  title: 'Burger Station SOP',
  category: '🍔 Kitchen Operations',
  description: 'Kako pripremiti sve varijante burgera, temperature, redosled sastavljanja',
  updated: 'Dec 10, 2025',
  author: 'Marko',
  views: 127,
  roles: 'Kuvar',
  locations: 'All',
  required: true,
  aiUsed: ['Troubleshooter', 'Onboarding'],
  expanded: true
}, {
  id: 2,
  title: 'Pancake Station SOP',
  category: '🍔 Kitchen Operations',
  description: 'Priprema smese, pečenje, filovanje i dekoracija palačinki',
  updated: 'Dec 8, 2025',
  author: 'Jovana',
  views: 89,
  roles: 'Kuvar',
  locations: 'All',
  required: true,
  aiUsed: ['Onboarding'],
  expanded: false
}, {
  id: 3,
  title: 'Food Safety & Hygiene',
  category: '🍔 Kitchen Operations',
  description: 'HACCP standardi, pranje ruku, unakrsna kontaminacija',
  updated: 'Dec 1, 2025',
  author: 'Ana',
  views: 234,
  roles: 'All Staff',
  locations: 'All',
  required: true,
  critical: true,
  aiUsed: ['Troubleshooter', 'Onboarding'],
  expanded: false
}];
export function Library() {
  const [showUploadModal, setShowUploadModal] = useState(false);
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-3000">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-3001">
        <div data-id="element-3002">
          <h1 className="text-2xl font-bold text-text-primary flex items-center gap-3" data-id="element-3003">
            Procedures{' '}
            <span className="text-lg font-normal text-text-secondary" data-id="element-3004">
              24 documents · 3 AI agents
            </span>
          </h1>
        </div>
        <div className="flex items-center gap-3" data-id="element-3005">
          <Button icon={<Plus size={16} data-id="element-3007" />} variant="secondary" data-id="element-3006">
            Add
          </Button>
          <Button icon={<Upload size={16} data-id="element-3009" />} onClick={() => setShowUploadModal(true)} data-id="element-3008">
            Upload
          </Button>
        </div>
      </div>

      <TabNavigation tabs={PROCEDURE_TABS} basePath="/procedures" data-id="element-3010" />

      {/* Filters */}
      <div className="flex flex-wrap gap-3 items-center mb-6" data-id="element-3011">
        <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-3012">
          All Categories <ChevronDown size={14} data-id="element-3013" />
        </button>
        <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-3014">
          All Locations <ChevronDown size={14} data-id="element-3015" />
        </button>
        <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-3016">
          All Roles <ChevronDown size={14} data-id="element-3017" />
        </button>
        <div className="relative ml-auto" data-id="element-3018">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary" data-id="element-3019" />
          <input type="text" placeholder="Search documents..." className="bg-background-elevated border border-white/10 rounded-lg pl-9 pr-4 py-2 text-sm focus:outline-none focus:border-accent-primary w-64" data-id="element-3020" />
        </div>
      </div>

      {/* Document List */}
      <div className="space-y-4" data-id="element-3021">
        {CATEGORIES.map(cat => <div key={cat.name} className="space-y-2" data-id="element-3022">
            <button className="w-full flex items-center justify-between p-3 bg-background-elevated/50 rounded-lg hover:bg-white/5 transition-colors" data-id="element-3023">
              <div className="flex items-center gap-3 font-bold" data-id="element-3024">
                {cat.expanded ? <ChevronDown size={18} data-id="element-3025" /> : <ChevronRight size={18} data-id="element-3026" />}
                <span data-id="element-3027">{cat.name}</span>
                <span className="text-text-secondary font-normal text-sm" data-id="element-3028">
                  ({cat.count} docs)
                </span>
              </div>
            </button>

            {cat.expanded && <div className="space-y-3 pl-4" data-id="element-3029">
                {DOCUMENTS.filter(doc => doc.category === cat.name).map(doc => <Card key={doc.id} className="group hover:border-white/20 transition-colors" noPadding data-id="element-3030">
                      {doc.expanded ? <div className="p-4" data-id="element-3031">
                          <div className="flex justify-between items-start mb-3" data-id="element-3032">
                            <div className="flex items-start gap-3" data-id="element-3033">
                              <div className="w-10 h-10 bg-accent-primary/10 rounded-lg flex items-center justify-center shrink-0 mt-1" data-id="element-3034">
                                <FileText className="text-accent-primary" size={20} data-id="element-3035" />
                              </div>
                              <div data-id="element-3036">
                                <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-3037">
                                  {doc.title}
                                  {doc.required && <span className="bg-accent-warning/10 text-accent-warning text-[10px] px-1.5 py-0.5 rounded font-bold flex items-center gap-1" data-id="element-3038">
                                      <Star size={10} fill="currentColor" data-id="element-3039" />{' '}
                                      Required
                                    </span>}
                                  {doc.critical && <span className="bg-accent-error/10 text-accent-error text-[10px] px-1.5 py-0.5 rounded font-bold" data-id="element-3040">
                                      Critical
                                    </span>}
                                </h3>
                                <p className="text-text-secondary text-sm mt-1 max-w-2xl" data-id="element-3041">
                                  {doc.description}
                                </p>
                              </div>
                            </div>
                            <div className="flex gap-2" data-id="element-3042">
                              <Button size="sm" variant="secondary" data-id="element-3043">
                                View
                              </Button>
                              <Button size="sm" variant="secondary" data-id="element-3044">
                                Edit
                              </Button>
                            </div>
                          </div>

                          <div className="flex flex-wrap gap-6 text-sm text-text-secondary pl-[52px]" data-id="element-3045">
                            <div data-id="element-3046">
                              Updated:{' '}
                              <span className="text-text-primary" data-id="element-3047">
                                {doc.updated}
                              </span>
                            </div>
                            <div data-id="element-3048">
                              By:{' '}
                              <span className="text-text-primary" data-id="element-3049">
                                {doc.author}
                              </span>
                            </div>
                            <div className="flex items-center gap-1" data-id="element-3050">
                              <Eye size={14} data-id="element-3051" /> {doc.views} views
                            </div>
                            <div data-id="element-3052">
                              Roles:{' '}
                              <span className="text-text-primary" data-id="element-3053">
                                {doc.roles}
                              </span>
                            </div>
                            <div data-id="element-3054">
                              Locations:{' '}
                              <span className="text-text-primary" data-id="element-3055">
                                {doc.locations}
                              </span>
                            </div>
                          </div>

                          {doc.aiUsed && <div className="mt-4 pl-[52px] pt-3 border-t border-white/5 flex items-center gap-2 text-xs" data-id="element-3056">
                              <Bot size={14} className="text-accent-primary" data-id="element-3057" />
                              <span className="text-text-secondary" data-id="element-3058">
                                Used by:
                              </span>
                              {doc.aiUsed.map((agent, i) => <span key={i} className="bg-white/5 px-2 py-0.5 rounded text-text-primary" data-id="element-3059">
                                  {agent}
                                </span>)}
                            </div>}
                        </div> : <div className="p-3 flex items-center justify-between cursor-pointer hover:bg-white/5" data-id="element-3060">
                          <div className="flex items-center gap-3" data-id="element-3061">
                            <ChevronRight size={16} className="text-text-secondary" data-id="element-3062" />
                            <FileText size={16} className="text-text-secondary" data-id="element-3063" />
                            <span className="font-medium" data-id="element-3064">{doc.title}</span>
                          </div>
                          <div className="flex items-center gap-6 text-sm text-text-secondary" data-id="element-3065">
                            <span className="flex items-center gap-1" data-id="element-3066">
                              <Eye size={14} data-id="element-3067" /> {doc.views}
                            </span>
                            {doc.required && <span className="flex items-center gap-1 text-accent-warning font-bold text-xs" data-id="element-3068">
                                <Star size={10} fill="currentColor" data-id="element-3069" /> Required
                              </span>}
                          </div>
                        </div>}
                    </Card>)}
              </div>}
          </div>)}
      </div>

      {/* Upload Modal */}
      {showUploadModal && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-3070">
          <Card className="w-full max-w-lg" data-id="element-3071">
            <div className="flex justify-between items-center mb-6" data-id="element-3072">
              <h3 className="text-xl font-bold" data-id="element-3073">Upload Document</h3>
              <button onClick={() => setShowUploadModal(false)} className="text-text-secondary hover:text-white" data-id="element-3074">
                <X size={20} data-id="element-3075" />
              </button>
            </div>

            <div className="space-y-4 mb-6" data-id="element-3076">
              <div className="border-2 border-dashed border-white/10 rounded-lg p-8 text-center hover:border-accent-primary/50 transition-colors cursor-pointer bg-white/5" data-id="element-3077">
                <Upload className="mx-auto h-10 w-10 text-text-secondary mb-3" data-id="element-3078" />
                <p className="font-medium" data-id="element-3079">Click to upload or drag and drop</p>
                <p className="text-xs text-text-secondary mt-1" data-id="element-3080">
                  Supports: .docx, .pdf, .doc
                </p>
              </div>

              <div data-id="element-3081">
                <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-3082">
                  Title
                </label>
                <input type="text" className="w-full bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" placeholder="e.g., Burger Station SOP" data-id="element-3083" />
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-3084">
                <div data-id="element-3085">
                  <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-3086">
                    Category
                  </label>
                  <select className="w-full bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" data-id="element-3087">
                    {CATEGORIES.map(c => <option key={c.name} data-id="element-3088">{c.name}</option>)}
                  </select>
                </div>
                <div data-id="element-3089">
                  <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-3090">
                    Roles
                  </label>
                  <select className="w-full bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" data-id="element-3091">
                    <option data-id="element-3092">All Roles</option>
                    <option data-id="element-3093">Kuvar</option>
                    <option data-id="element-3094">Vođa smene</option>
                  </select>
                </div>
              </div>

              <div data-id="element-3095">
                <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-3096">
                  Description
                </label>
                <textarea className="w-full bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary h-20" placeholder="Short summary of the document..." data-id="element-3097"></textarea>
              </div>

              <div className="space-y-2" data-id="element-3098">
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-3099">
                  <input type="checkbox" className="rounded border-white/10 bg-background text-accent-primary focus:ring-accent-primary" defaultChecked data-id="element-3100" />
                  <span className="text-sm" data-id="element-3101">Required for onboarding</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-3102">
                  <input type="checkbox" className="rounded border-white/10 bg-background text-accent-primary focus:ring-accent-primary" defaultChecked data-id="element-3103" />
                  <span className="text-sm" data-id="element-3104">Available to AI agents</span>
                </label>
              </div>
            </div>

            <div className="flex justify-end gap-3" data-id="element-3105">
              <Button variant="secondary" onClick={() => setShowUploadModal(false)} data-id="element-3106">
                Cancel
              </Button>
              <Button onClick={() => setShowUploadModal(false)} data-id="element-3107">Upload</Button>
            </div>
          </Card>
        </div>}
    </div>;
}